export default __webpack_public_path__ + "static/media/3663.555ca02f.png";